// middleware/login.js
import { useStrapiUser } from '#imports'
import { resolveFirstRoute } from '~/composables/useFirstRoute'

export default defineNuxtRouteMiddleware(async (to) => {
  if (process.server) return
  const user = useStrapiUser()
  if (user.value && to.path === '/login') {
    const firstRoute = await resolveFirstRoute(user.value.id)
    return navigateTo(firstRoute)
  }
})
